<script setup lang="ts">
import { ISensor } from '@/interfaces/entities/sensor';
import { getSensorColor, translateSensorType } from '@/interfaces/enums';
import { useSensorStore } from '@/store/sensor';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  sensor: ISensor
}>()
const t = useI18n().t
const store = useSensorStore()
</script>

<template>
  <div class="h-full">
    <div
      :class="[
        'relative flex h-full cursor-pointer flex-col bg-white px-4 py-3 shadow-sm transition-all duration-200 ease-in-out hover:shadow-md hover:bg-gray-50',
        sensor.has_open_alarm && 'sensor-with-open-alarm'
      ]">
      <div :class="['absolute bottom-0 left-0 top-0 w-1']"></div>
      <div class="mb-2.5 flex items-start justify-between gap-2">
        <h1 class="flex-1 text-base font-semibold text-black-2 line-clamp-2 leading-snug">
          {{ sensor.name }}
        </h1>
        <div :class="`px-2.5 py-1 text-sm font-medium text-white flex-shrink-0 ${getSensorColor(sensor.sensor_type)}`">
          {{ translateSensorType(sensor.sensor_type) }}
        </div>
      </div>
      <div class="space-y-2 text-sm text-gray-600">

        <div>
          <span class="font-medium">SubID:</span> {{ sensor.subid }}
        </div>
      </div>
    </div>
  </div>
</template>
